import { render, staticRenderFns } from "./Idp.vue?vue&type=template&id=5869a8d1&scoped=true"
import script from "@/views/Groups/Tabs/Idp.ts?vue&type=script&lang=ts&external"
export * from "@/views/Groups/Tabs/Idp.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Groups/Tabs/idp.scss?vue&type=style&index=0&id=5869a8d1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869a8d1",
  null
  
)

export default component.exports